// extracted by mini-css-extract-plugin
export default {"tag":"light_tag__J0n4z color_colorLightSelect__177KE"};